// Lookup helpers over the shared country list.

import countriesData from '../data/countries.json';

const byCode = new Map(countriesData.countries.map((country) => [country.code, country]));

export const countryByCode = (code) => byCode.get(String(code || '').toUpperCase()) || null;

/** Path to a country's rounded flag image, served from /public. */
export const flagSrc = (country) => (country ? `/${country.flag_rounded}` : '');
